import ShopifyGetProduct from "./ShopifyGetProduct";
import GetCustomizerImages from "./GetCustomizerImages";
import ParseProduct from "./ParseProduct";
import ShopifyGetPatches from "./ShopifyGetPatches";

const editOrderHelper = async (order) => {
  const productID = order?.productId.replace("gid://shopify/Product/", "");
  const variantID = order?.variantId.replace("gid://shopify/ProductVariant/", "");
  const _previewURL = order?.customAttributes?.find((e) => e.key === "_previewURL")?.value;
  let shopifyPatches;
  let ppi;
  let characterName;

  try {
    const results = await Promise.allSettled([
      ShopifyGetProduct(productID),
      GetCustomizerImages(productID),
    ]);

    const [product, images] = results.map((e) => e.value);

    if (product) {
      ppi = ParseProduct(product, images).variants.find((e) => e.id.includes(variantID))?.ppi;
    }
  } catch (e) {
    console.log(e);
  }

  const patches = order.patches.map(({ width, height, ...rest }) => ({
    ...rest,
    bou: {
      coords: rest.coo,
      height: Math.floor(height * ppi),
      width: Math.floor(width * ppi),
      top: Math.floor(rest.top),
      left: Math.floor(rest.lef),
    },
  }));

  try {
    const results = await ShopifyGetPatches(patches.map((e) => e.id));

    shopifyPatches = patches.reduce((array, patch) => {
      const find = results.find((result) => result.id === patch.id);
      if (find) {
        const width = find.width * ppi;
        const height = find.height * ppi;
        array.push({
          ...find,
          center: patch.cen,
          coordinates: patch.coo,
          bounds: patch.bou,
          position: patch.pos,
          rotation: patch.rot,
          top: patch.cen[1] - height / 2,
          left: patch.cen[0] - width / 2,
          visible: true,
        });
      }
      return array;
    }, []);
  } catch (e) {
    console.log(e);
  }

  try {
    if (_previewURL) {
      const urlParams = new URLSearchParams(new URL(_previewURL).search);
      urlParams.has("characterName") && (characterName = urlParams.get("characterName"));
    }
  } catch (e) {
    console.log(e);
  }

  return { shopifyPatches, productID, variantID, characterName };
};

export default editOrderHelper;
